.inputHint {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: var(--ixf-space-2) var(--ixf-space-4);
  color: var(--ixf-text-tone-md);
  background-color: var(--ixf-color-neutral-xlt);
  font-weight: var(--ixf-font-weight-main-medium);
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-family: var(--ixf-font-family-main);
}
